import React, { forwardRef } from 'react';

import { cn } from '@lyearn/style';
import { Stack } from '@lyearn/ui';

import { ButtonContainerProps } from './types';

const ButtonContainer = forwardRef<HTMLDivElement, ButtonContainerProps>((props, forwardedRef) => {
  const { className, children, onClick: onClickProps, buttonId, ...rest } = props;

  const onClick = React.useCallback(() => {
    onClickProps?.(buttonId);
  }, [buttonId, onClickProps]);

  return (
    <Stack
      ref={forwardedRef}
      alignItems="center"
      className={cn('group rounded-8 border border-border bg-bg-primary px-24 py-20', className)}
      gapX={16}
      justifyContent="between"
      onClick={onClick}
      {...rest}>
      {children}
    </Stack>
  );
});

export default ButtonContainer;
